import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Navigate as Redirect } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, isNil } from 'lodash'
import actions from '../../actions/Users'
import alert from '../../alert'
import InternalUserForm from './InternalUserForm'

export class InternalUserCreate extends Component {
  static propTypes = {
    create: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    generalError: PropTypes.string,
    resourceErrors: PropTypes.object,
    created: PropTypes.bool.isRequired,
    id: PropTypes.number,
    requestInProgress: PropTypes.bool.isRequired,
    defaultRoles: PropTypes.array.isRequired
  }

  componentWillUnmount() {
    this.props.reset()
  }

  handleSubmit = (values, dispatch) => {
    this.props.create(this.translateValues(values))
  }

  translateValues = (values) => {
    const newValues = cloneDeep(values)

    if (!isNil(newValues.roles)) {
      newValues.user_roles = newValues.roles.map((roleName) => ({
        role_id: this.props.defaultRoles.find((role) => role.name === roleName).id
      }))
    }

    return newValues
  }

  redirect(path) {
    return <Redirect replace to={path} />
  }

  render() {
    const { generalError, resourceErrors } = this.props

    if (!isNil(generalError)) {
      alert(generalError)
    }

    if (this.props.created && !isNil(this.props.id)) {
      return this.redirect(`/internal_users/${this.props.id}`)
    }

    const errors = isNil(resourceErrors) ? {} : resourceErrors

    return (
      <div className="content">
        <h2>New Internal User</h2>
        <div>
          <InternalUserForm
            handleSubmit={this.handleSubmit}
            errors={errors}
            requestInProgress={this.props.requestInProgress}
            defaultRoles={this.props.defaultRoles}
            initialValues={{
              user_type: 'internal',
              username: null,
              email: null,
              user_roles: []
            }}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const slice = state.users.create

  return {
    generalError: slice.generalError,
    resourceErrors: slice.resourceErrors,
    requestInProgress: slice.requestInProgress,
    id: slice.id,
    created: slice.created,
    defaultRoles: state.login.session.configuration.roles
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  create: actions.create.main,
  reset: actions.create.reset
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(InternalUserCreate)
